module.exports = __webpack_public_path__ + "static/img/pillow.38e86c63.jpg";